import { Link } from "react-router-dom";
import { ArrowUpRight, Camera, Palette, Megaphone, Store, PenTool, Sparkles } from "lucide-react";
import { PageHero, SectionHead, CTABand } from "@/components/PageHero";
import { Reveal } from "@/components/anim";
import { IMG } from "@/lib/img";

const SERVICES = [
  { icon: Store, name: "Visual merchandising" },
  { icon: Store, name: "Retail display setup" },
  { icon: Sparkles, name: "Window displays" },
  { icon: PenTool, name: "Custom signage" },
  { icon: PenTool, name: "Graphic design" },
  { icon: PenTool, name: "Flyer design" },
  { icon: Megaphone, name: "Social-media content" },
  { icon: Camera, name: "Content creation" },
  { icon: Camera, name: "Product photography" },
  { icon: Palette, name: "Branding assistance" },
  { icon: PenTool, name: "Website design" },
  { icon: Megaphone, name: "Social-media marketing" },
  { icon: Megaphone, name: "Launch marketing" },
  { icon: Store, name: "Setup and breakdown assistance" },
  { icon: Sparkles, name: "Event support" },
];

export default function Services() {
  return (
    <>
      <PageHero
        eyebrow="Services"
        lines={[
          <>We help bring</>,
          <>
            your brand <em>to life.</em>
          </>,
        ]}
        sub="Optional add-on services to make your rental effortless — from the first flyer to the final breakdown."
      />

      <section className="bg-paper pb-24 sm:pb-32" data-testid="services-grid">
        <div className="mx-auto max-w-[1440px] px-6 lg:px-10">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {SERVICES.map((s, i) => (
              <Reveal key={s.name} delay={i * 0.03}>
                <div className="group flex items-center gap-4 rounded-2xl border border-beige/60 bg-white/80 px-6 py-5 transition-all duration-500 hover:-translate-y-0.5 hover:border-sanddeep">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-blush transition-colors duration-300 group-hover:bg-blushdeep">
                    <s.icon size={16} strokeWidth={1.5} className="text-ink" />
                  </span>
                  <p className="text-sm uppercase tracking-[0.12em] text-ink">{s.name}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-sand py-24 sm:py-32" data-testid="services-feature">
        <div className="mx-auto grid max-w-[1440px] grid-cols-1 items-center gap-14 px-6 lg:grid-cols-2 lg:gap-20 lg:px-10">
          <div>
            <SectionHead
              eyebrow="Full-service support"
              title={
                <>
                  Need more than space?
                  <br />
                  <em>Let Essandtials help create the experience.</em>
                </>
              }
              sub="Tell us what you're planning when you book — we'll recommend the services, styling, and setup that fit your brand and budget."
            />
          </div>
          <Reveal delay={0.15}>
            <img
              src={IMG.designerDesk}
              alt="Creative entrepreneur working on brand designs"
              loading="lazy"
              className="aspect-[4/3] w-full rounded-3xl object-cover shadow-[0_30px_80px_rgba(26,24,23,0.12)]"
            />
          </Reveal>
        </div>
      </section>

      <CTABand
        title={
          <>
            Space + services.
            <br />
            <em>One conversation away.</em>
          </>
        }
        cta="Start Your Inquiry"
        to="/book"
        testid="services-cta-button"
      />
    </>
  );
}
